import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  const [featured, ...rest] = testimonials;
  return <section className="border-b border-line bg-sand" data-id="element-243" data-mp="1n0addghtiqw3">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-244" data-mp="1mzsaw24kbgfq">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-245" data-mp="1r0ubone4o0jt">
          <div data-id="element-246" data-mp="1d1be2oiy07lr">
            <Eyebrow data-id="element-247" data-mp="1d0t9n4m4mn2r">La eligen profes de guitarra</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-248" data-mp="1i0xuf6u2i3ys">
              Lo que dicen los profes
            </h2>
          </div>
          <p className="text-[13px] text-ink-mute" data-id="element-249" data-mp="14399y03wwyu9">
            Estudios, academias y profesores particulares
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-250" data-mp="2yeo0gj4qz2b2">
          <figure className="flex h-full flex-col rounded-2xl border border-line bg-paper p-8 shadow-card sm:p-10" data-id="element-251" data-mp="2yd33ynyvh9ak">
            <blockquote className="font-display text-2xl italic leading-snug text-ink sm:text-[28px]" data-id="element-252" data-mp="2v1krso7d49vr">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-8" data-id="element-253" data-mp="2q1ydscjpmplw">
              <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-ink text-sm font-semibold text-cream" data-id="element-254" data-mp="34rnl6piebpum">
                {featured.initials}
              </span>
              <span data-id="element-255" data-mp="273n5no4g4r4g">
                <span className="block text-sm font-semibold text-ink" data-id="element-256" data-mp="2745ah956cdnz">{featured.name}</span>
                <span className="block text-[13px] text-ink-mute" data-id="element-257" data-mp="2m0mo670u64dp">{featured.role}</span>
              </span>
            </figcaption>
          </figure>

          <ul className="grid gap-4" data-id="element-258" data-mp="2h08eylni0oe3">
            {rest.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-line bg-paper px-6 py-5" data-id="element-259" data-mp="19m5ju6otatw">
                <blockquote className="text-[15px] leading-relaxed text-ink-soft" data-id="element-260" data-mp="3esh7rhiqpk8">
                  “{item.quote}”
                </blockquote>
                <div className="mt-auto flex items-center gap-3 pt-4" data-id="element-261" data-mp="8ck9imm2sdoy">
                  <span aria-hidden="true" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sand text-[11px] font-semibold text-ink-soft" data-id="element-262" data-mp="dcf1kthl79bl">
                    {item.initials}
                  </span>
                  <span className="text-[13px] text-ink" data-id="element-263" data-mp="3lsi98z8p8xzx">
                    <span className="font-semibold" data-id="element-264" data-mp="3lt1fvjswfzyn">{item.name}</span>
                    <span className="text-ink-mute" data-id="element-265" data-mp="3qqthx6n9d2gk"> · {item.role}</span>
                  </span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}